export const ADD_FORM = "add_company_form";
export const UPDATE_INCORPORATION_DATE_FORM = "update_incorporation_date_form";
